
import React from 'react';
import { FormGroup, Label, Input } from 'reactstrap';
import { connect } from 'react-redux';
import { fetchStates } from '../../../../../Redux/Actions/CommonActions';
import { DropDownList } from '@progress/kendo-react-dropdowns';
//import Slider from "react-slick";
//import axios from 'axios'
//import { auth } from '../../../../../../services';
//import { ROOT_API_URL } from "../../../../../../api-config";
import { updateShipping } from '../../../../../Redux/Actions/EndUser/StoreActions';

class StoreShippingInfo extends React.Component {
    constructor(props) {
        super(props);

        var shippingInfo = props.store && props.store.shippingInfo ? props.store.shippingInfo : null;

        this.state = {
            Address1: shippingInfo && shippingInfo.Address1 ? shippingInfo.Address1 : "",
            Address2: shippingInfo && shippingInfo.Address2 ? shippingInfo.Address2 : "",
            City: shippingInfo && shippingInfo.City ? shippingInfo.City : "",
            Zip: shippingInfo && shippingInfo.Zip ? shippingInfo.Zip : "",
            StateId: shippingInfo && shippingInfo.StateId ? shippingInfo.StateId : 0,
            StateObject: shippingInfo && shippingInfo.StateObject ? shippingInfo.StateObject : { id: 0, name: "" },
            states: shippingInfo && shippingInfo.states && shippingInfo.states.length ? shippingInfo.states : []
        };
    }

    componentDidMount() {
        this.props.fetchStates();

        this.props.updateShipping(this.state);
    }

    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        }, function () {
            this.props.updateShipping(this.state);
        });
    }

    handleState = (event) => {
        console.log(event.target.value);
        this.setState({
            StateObject: event.target.value,
            StateId: event.target.value.id
        }, function () {
            this.props.updateShipping(this.state);
        });
    }

    render() {
        return (
            <div className="">
                <div className="row">
                    <div className="col-sm-12 col-md-6XX card-section-address">
                        <FormGroup>
                            <Label htmlFor="Address1">Address 1</Label>
                            <Input type="text"
                                id="Address1"
                                value={this.state.Address1}
                                onChange={this.handleChange}
                                name="Address1"
                                invalid={this.props.touched.Address1 && this.state.Address1 === '' ? true : false}
                                onBlur={this.props.handleBlur('Address1')}
                            />
                        </FormGroup>
                    </div>
                    <div className="col-sm-12 col-md-6XX card-section-address">
                        <FormGroup>
                            <Label htmlFor="Address2">Address 2</Label>
                            <Input type="text"
                                id="Address2"
                                value={this.state.Address2}
                                onChange={this.handleChange}
                                name="Address2"
                            />
                        </FormGroup>
                    </div>
                    <div className="col-sm-12 col-md-4XX card-section-city">
                        <FormGroup>
                            <Label htmlFor="City">City</Label>
                            <Input type="text"
                                id="City"
                                value={this.state.City}
                                onChange={this.handleChange}
                                name="City"
                                invalid={this.props.touched.City && this.state.City === '' ? true : false}
                                onBlur={this.props.handleBlur('City')}
                            />
                        </FormGroup>
                    </div>
                    <div className="col-sm-6 col-md-4XX card-section-state">
                        <FormGroup>
                            <label htmlFor="state">State </label>
                            <DropDownList data={this.props.common.states}
                                name="state"
                                textField="name"
                                dataItemKey="id"
                                onChange={this.handleState}
                                value={this.state.StateObject}
                                className={this.props.touched.StateObject && this.state.StateObject.name === '' ? "error" : ""}
                                onBlur={this.props.handleBlur('StateObject')}
                            />
                        </FormGroup>
                    </div>
                    <div className="col-sm-6 col-md-4XX card-section-zip">
                        <FormGroup>
                            <Label htmlFor="Zip">Zip Code</Label>
                            <Input type="text"
                                id="Zip"
                                value={this.state.Zip}
                                onChange={this.handleChange}
                                name="Zip"
                                placeholder="Zip"
                                invalid={this.props.touched.Zip && this.state.Zip === '' ? true : false}
                                onBlur={this.props.handleBlur('Zip')}
                            />
                        </FormGroup>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        store: state.store,
        common: state.common
    }
}

export default connect(mapStateToProps, { updateShipping, fetchStates })(StoreShippingInfo);
